// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"5706":"3153330af47fc26a725a","6127":"af587204ca26614234f9"}[chunkId] + "";
};